import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import lang from 'lang'
import { changeModal } from 'services/actions'

import NudgeTask from './task'
import AssignNudgeModal from './assign-nudge-modal'
import { publishNudge, unpublishNudge } from './service/actions'

@connect(
  (state) => ({
    user: state.root.user,
  }),
  (dispatch) => ({
    publishNudge: (payload) => dispatch(publishNudge(payload)),
    unpublishNudge: (payload) => dispatch(unpublishNudge(payload)),
    changeModal: (params) => dispatch(changeModal(params)),
  }),
)
export default class NudgeAssignment extends React.Component {
  static propTypes = {
    user: PropTypes.object,
    nudgeSet: PropTypes.object.isRequired,
    publishNudge: PropTypes.func.isRequired,
    unpublishNudge: PropTypes.func.isRequired,
    changeModal: PropTypes.func,
  }

  get isAssigned() {
    return this.props.nudgeSet.is_static || this.props.nudgeSet.assigned_nudge_set
  }

  get assignmentAllowed() {
    return !this.props.nudgeSet.is_static
  }

  publishHandler() {
    return () => {
      const { nudgeSet, user } = this.props

      if (!user.school_id) return

      this.props.publishNudge({
        nudgeSetId: nudgeSet.id,
        nudgeSetName: nudgeSet.title,
        schoolId: user.school_id,
        schoolName: user.school,
        personId: user.id,
      })
    }
  }

  confirmPublishHandler() {
    return () => {
      this.props.changeModal({
        isOpen: true,
        hideCloseButton: true,
        aria: {
          labelledby: 'confirm-nudge-assignment-header',
        },
        className: 'confirm-nudge-assignment',
        content: (
          <AssignNudgeModal
            bodyText={lang.dashboard.nudges.publishText}
            confirmText={lang.dashboard.nudges.confirmPublishButton}
            cancelText={lang.dashboard.nudges.cancelAssignmentButton}
            onClickHandler={this.publishHandler()}
          />
        ),
      })
    }
  }

  unpublishHandler() {
    return () => {
      const { nudgeSet, user } = this.props

      if (!user.school_id) return

      this.props.unpublishNudge({
        nudgeSetId: nudgeSet.id,
        nudgeSetName: nudgeSet.title,
        schoolId: user.school_id,
        schoolName: user.school,
      })
    }
  }

  confirmUnpublishHandler() {
    return () => {
      this.props.changeModal({
        isOpen: true,
        hideCloseButton: true,
        aria: {
          labelledby: 'confirm-nudge-assignment-header',
        },
        className: 'confirm-nudge-assignment',
        content: (
          <AssignNudgeModal
            alert
            bodyText={lang.dashboard.nudges.unpublishText}
            confirmText={lang.dashboard.nudges.confirmUnpublishButton}
            cancelText={lang.cancelButton}
            onClickHandler={this.unpublishHandler()}
          />
        ),
      })
    }
  }

  renderActions() {
    const { isAssigned } = this
    return (
      <div className="nudge-task-action">
        {isAssigned && (
          <div className="assigned-label">
            <i className="icon icon-check" />
            {lang.dashboard.nudges.published}
          </div>
        )}
        <button
          type="button"
          onClick={!isAssigned ? this.confirmPublishHandler() : this.confirmUnpublishHandler()}
          disabled={!this.assignmentAllowed}
          className="hollow assign button">
          {isAssigned ? lang.dashboard.nudges.unpublish : lang.dashboard.nudges.publish}
        </button>
      </div>
    )
  }

  render() {
    const { nudgeSet } = this.props
    const { isAssigned } = this

    return (
      <>
        <li className="setup">
          <ul className="nudges-task-list">
            {_.map(nudgeSet.nudges, (task) => (
              <NudgeTask
                key={task.id}
                task={task}
                showStats={isAssigned}
                showAction={isAssigned}
                nudgeSet={nudgeSet}
              />
            ))}
          </ul>
          {this.renderActions()}
        </li>
        {nudgeSet.guide_instructions ? (
          <li className="instructions">
            <p dangerouslySetInnerHTML={{ __html: nudgeSet.guide_instructions }} />
          </li>
        ) : null}
      </>
    )
  }
}
